// extracted by mini-css-extract-plugin
export var button = "styles-module__button___g5W3q";
export var resultList = "styles-module__resultList___HgH_A";